export default {
  'moduleTitle.address': 'Alamat',
  'moduleTitle.address_details': 'Alamat lengkap',
  'moduleTitle.activity_details': 'Info kegiatan',
  'moduleTitle.add_log': 'Tambahkan catatan',
  'moduleTitle.award_level': 'Tingkatan Award',
  'moduleTitle.adventurous_journey': 'AJ Perjalanan Bertualang',
  'moduleTitle.already_assessed': 'Sudah di assess',
  'moduleTitle.approved': 'Disetujui!',
  'moduleTitle.assessor_details': 'Info Assessor',
  'moduleTitle.authorising_contact_license_holder': 'Pihak Otoritas/Pemegang Lisensi',
  'moduleTitle.category_journey_details': '{jenis} Info perjalanan',
  'moduleTitle.complete_report': 'Laporan lengkap',
  'moduleTitle.completed_progress': 'Dinyatakan lengkap {selesai}/{total}',
  'moduleTitle.congratulation': 'Selamat!',
  'moduleTitle.confirming_email_address': 'Konfirmasikan alamat email',
  'moduleTitle.contact_details': 'Alamat lengkap',
  'moduleTitle.edit_log': 'Ubah catatan',
  'moduleTitle.event_journey': '{acara} Perjalanan',
  'moduleTitle.forgotten_password': 'Lupa kata sandi',
  'moduleTitle.great_you_are_almost_there': 'Bagus, kamu hampir mencapai tujuan. Langkah berikutnya adalah penyelesaian administrasi untuk tingkat Award berikutnya.',
  'moduleTitle.home_address': 'Alamat rumah',
  'moduleTitle.journey_overview': 'Garis besar perjalanan',
  'moduleTitle.log_detail': 'Catatan lengkap',
  'moduleTitle.login': 'Masuk',
  'moduleTitle.new_activity': 'Kegiatan baru',
  'moduleTitle.new_event_journey': 'Perjalanan baru',
  'moduleTitle.new_residential_project': 'Proyek Pemukiman baru',
  'moduleTitle.notRegistred': 'Belum terdaftar?',
  'moduleTitle.nominated_award_leader_contact_details': 'Info lengkap Award Leader yang dinominasikan',
  'moduleTitle.nominated_award_leader': 'Award Leader yang dinominasikan',
  'moduleTitle.organisation_address': 'Alamat organisasi',
  'moduleTitle.organisation_details': 'Info lengkap organisasi',
  'moduleTitle.online_record_book_account': 'Akun Online Record Book',
  'moduleTitle.page_not_found': '404-laman tidak ditemukan',
  'moduleTitle.personal_details': 'Data diri lengkap',
  'moduleTitle.preparation_and_training': 'Persiapan dan Pelatihan',
  'moduleTitle.profile_guardian_consent': 'Persetujuan Orang Tua / Wali',
  'moduleTitle.profile_questions': 'Pertanyaan mengenai profil',
  'moduleTitle.registration_for_level': 'Pendaftaran untuk tingkat Award berikutnya',
  'moduleTitle.residential_project': 'Proyek Pemukiman',
  'moduleTitle.residential_project_details': 'Info lengkap Proyek Pemukiman',
  'moduleTitle.reset_password': 'Buat ulang kata sandi',
  'moduleTitle.welcome_to_the_orb': 'Selamat datang di Online Record Book',
  'moduleTitle.we_have_sent_you_an_email': 'Kami telah mengirimkan email dengan link untuk aktifasi',
  'moduleTitle.your_registration_is_complete': 'Registrasi sudah lengkap',
  'formTitle.activity_details': 'Info lengkap kegiatan',
  'formTitle.assessor_details': 'Info Assessor',
  'formTitle.supervisors_details': 'Info Supervisor',
  'formTitle.preparation_and_training_activities': 'Kegiatan persiapan dan pelatihan',
  'formTitle.added_preparation_activities': 'Tambahan kegiatan persiapan dan pelatihan',
  'label.add_picture': 'tambahkan foto',
  'label.address_first_line': 'Alamat (baris pertama)',
  'label.address_second_line': 'Alamat (baris kedua - opsional)',
  'label.are_you_already_running_award': 'Apakah anda pernah menyelenggarakan program Award?',
  'label.are_you_the_main_award_leader': 'Apakah anda merupakan Award Leader utama atau Koordinator dalam Unit Award anda?',
  'label.award_participant': 'Peserta Award',
  'label.award_leader': 'Award Leader',
  'label.birthdate': 'Tanggal Lahir',
  'label.category': 'Jenis/kategori',
  'label.change_locale': 'Ubah lokasi',
  'label.choose_project': 'Pilih Proyek',
  'label.city': 'Kota',
  'label.choose_as_major_activity': 'Tentukan kegiatan utama',
  'label.date': 'Tanggal',
  'label.date_of_birth': 'Tanggal lahir',
  'label.description_of_progress': 'Penjelasan mengenai kemajuan mu',
  'label.duration': 'lama waktu (menit)',
  'label.email': 'email',
  'label.email_address': 'alamat email',
  'label.email_again': 'alamat email lagi',
  'label.employment_status': 'status pekerjaan',
  'label.end_date': 'Tanggal Akhir',
  'label.enter_his_email': 'masukan alamat email',
  'label.entered_transaction_id': 'ID transaksi anda',
  'label.first_name': 'Nama depan',
  'label.gender': 'Gender',
  'label.goal': 'Tujuan',
  'label.journey_activity': 'Kegiatan Perjalanan',
  'label.journey_objective': 'Tujuan Perjalanan',
  'label.journey_observations': 'Observasi selama perjalanan',
  'label.journey_type': 'Jenis perjalanan',
  'label.last_name': 'Nama belakang',
  'label.level': 'TIngkat',
  'label.location': 'Lokasi',
  'label.logout': 'Keluar',
  'label.major': 'Utama',
  'label.middle_name': 'Nama tengah',
  'label.mode_of_transport': 'Jenis transportasi',
  'label.my_award_leader': 'Award Leaderku',
  'label.name': 'Nama',
  'label.nationality': 'Kebangsaan',
  'label.no': 'Tidak',
  'label.no_results': 'Tidak ada hasil',
  'label.note': 'Catatan',
  'label.note_for_assessor': 'Catatan untuk Assessor',
  'label.note_for_leader': 'Catatan untuk Leader',
  'label.optional': 'pilihan/opsional',
  'label.organisation_name': 'Nama organisasi',
  'label.organisation_type': 'Jenis organisasi',
  'label.others': 'lainnya',
  'label.password': 'Kata sandi',
  'label.password_again': 'Ulangi kata sandi',
  'label.project_location': 'Lokasi proyek',
  'label.pay_online': 'Bayar online',
  'label.pay_award_leader_or_unit': 'Bayar ke Award Leader/Unit',
  'label.payment_not_required': 'Pembayaran tidak dibutuhkan',
  'label.payment_type': 'Jenis pembayaran',
  'label.phone': 'Telpon',
  'label.phone_number': 'Nomor telpon',
  'label.phone_type': 'Jenis telepon',
  'label.profile': 'Profile',
  'label.reset_password': 'Buat Ulang Kata Sandi',
  'label.region': 'Provinsi',
  'label.relationship': 'Hubungan',
  'label.role_in_organisation': 'Peran dalam Organisasi',
  'label.select_country': 'Pilih Negara',
  'label.select_your_au': 'Pilih Award Unit mu',
  'label.start_typing': 'Mulai mengetik',
  'label.start_date': 'Tanggal Mulai',
  'label.select': 'Pilih',
  'label.select_async': 'Mulai mengetik',
  'label.select_your_operating_authority': 'Pilih Otoritas Penyelenggara',
  'label.specify_category': 'Mohon sebutkan kategori',
  'label.subcategory': 'Sub Kategori',
  'label.title': 'Titel',
  'label.username': 'Nama User',
  'label.what_is_your_role': 'Apa peran anda dalam organisasi?',
  'label.where_have_you_completed': 'Dimana anda menyelesaikan program?',
  'label.yes': 'Ya',
  'label.your_changes_havent_been_saved': 'Perubahan yang ada buat belum disimpan. Data akan hilang.',
  'label.zip': 'Kode Pos',
  'label.adventurous_journey': 'Perjalanan Bertualang (AJ)',
  'label.after_your_journey_describe': 'Ceritakan observasi yang kamu peroleh dari Perjalanan Bertualang dalam beberapa kalimat',
  'label.because_your_age_is_under_18': 'Karena kamu masih dibawah 18 tahun, kami membutuhkan surat pernyataan dari Orang Tua/Wali untuk menyetujui kepesertaan mu.',
  'label.before_you_head_to_journey': 'Sebelum kamu dapat melanjutkan Perjalanan Bertualang untuk penilaian, kamu wajib melengkapi lembar Persiapan dan Pelatihan',
  'label.before_entering_new_level': 'Sebelum memasuki tingkat Award yang baru, harap konfirmasikan bahwa info mengenai diri pribadi masih berlaku',
  'label.bring_required_amount_to_your_award_leader': 'Membawa sejumlah dana yang telah disepakati bersama untuk Award Leader atau Koordinator Award didalam Unit mu.',
  'label.do_you_have_any_other_level': 'Apakah kamu telah menyelesaikan program Award di level sebelumnya',
  'label.do_you_know_who_is_your_award_leader': 'Apakah kamu tahu siapa Award Leadermu?',
  'label.going_on_an_expedition': 'Dengan bergabung dalam ekspedisi, akan memberikan kamu kesempatan untuk bertualang, bekerja sama dalam kelompok dan dapat melaksanakan initiatif mu sendiri',
  'label.going_on_residential_gives_chance': 'Dengan menjalankan Proyek Pemukiman, memberikan dirimu kesempatan untuk belajar bagaimana bekerja sama dengan berbagai orang dari latar belakang yang berbeda dan meningkatkan kepercayaan diri untuk tinggal di lingkungan yang baru',
  'label.i_confirm_that_i_meet': 'Saya mengkonfirmasikan bahwa saya telah memenuhi seluruh peraturan dan persyaratan dari NAO (National Award Office - Kantor Award Nasional)',
  'label.i_agree_to_volunteer_code': 'Saya menyatakan bersedia mematuhi "kode etik relawan/volunteer". Untuk memperoleh informasi lebih lanjut click disini',
  'label.i_have_read_the_terms_and_conditions': 'Saya telah membaca seluruh tata cara persyaratan dan kondisi dan menyatakan setuju ',
  'label.i_will_bring_the_consent_to_my_award_leader_later': 'Saya akan membawa surat pernyataan diatas dan menyerahkan kepada Award Leader saya',
  'label.if_you_are_from_orphanage': 'Apabila kamu berasal dari sebuah panti asuhan atau penitipan, anda dibebaskan dari kewajiban membayar biaya administrasi Award',
  'label.here_you_can_add_activity': 'Kamu  dapat menambahkan catatan mengenai kegiatan persiapan dan pelatihan',
  'label.how_do_you_want_to_apply': 'Bagaimana kamu akan menyampaikan aplikasi?',
  'label.my_parent_consent_has_been_already_given': 'Surat persetujuan Orang Tua/Wali saya telah disampaikan kepada Award Leader',
  'label.my_parent_will_confirm_consent_by_email': 'Orant Tua/Wali saya akan mengkonfirmasikan surat persetujuan melalui email',
  'label.major_activity_means_that_you_have_to_spent': 'Kegiatan menjadi kegiatan utama bila kamu menghabiskan waktu 2 kali lebih banyak dari pada kegiatan pilihan lainnya',
  'label.not_sure_about_your_auth': 'Tidak yakin mengenai Otoritas Award anda? Harap hubungi kami di...',
  'label.page_not_found': '404- Laman tidak ditemukan',
  'label.please_fill_in_the_following': 'Harap lengkapi informasi mengenai PIC yang memiliki otoritas / memegang lisensi dalam organisasi anda',
  'label.register_a_new_account_as': 'Daftar akun baru sebagai:',
  'label.residential_project': 'Proyek Pemukiman',
  'label.select_your_award_unit': 'Pilih Award Unit mu',
  'label.the_expedition_can_be_faraway': 'Program Ekspedisimu bisa berlokas jauh dari atau dekat dari tempat tinggal mu, dapat dipilih sesuai dengan rencanamu, dan banyak cara dapat ditempuh untuk mewujudkan hal ini.',
  'label.to_log_your_process_on_orb': 'Untuk membuat catatan tentang kemajuan dalam ORB Buku Catatan Online - Online Record Book kamu harus memiliki akun ORB. Harap masukan informasi lengkap mengenai dirimu disini.',
  'label.waiting_for_assessment': 'Menunggu Penilaian',
  'label.waiting_for_sign_off': 'Menunggu Persetujuan dari Award Leader',
  'label.we_have_sent_you_an_email': 'Kami telah mengirimkan kepada kamu email berikut link aktifasinya',
  'label.what_level_of_the_award': 'Sebutkan tingkat Award yang mana yang ingin kamu daftarkan?',
  'label.you_are_now_registering_as_participant': 'Kamu saat ini sedanng mendaftar menjadi Peserta Award',
  'label.you_are_now_registering_as_award_unit': 'Anda saat ini sedang mendaftar menjadi Award Unit',
  'label.you_can_use_my_photos_for_promotional_purposes': 'Sebagai peserta Award, saya telah memberikan persetujuan untuk Yayasan untuk menggunakan dokumentasi/foto saya untuk tujuan promosi/sosialisasi',
  'label.you_can_send_activity_for_approval': 'Kamu dapat mengirimkan catatan kegiatanmu kepada Assessor untuk mendapat persetujuan',
  'label.you_can_send_activity_for_leader': 'Kirim catatan kegiatanmu kepada Award Leader untuk mendapat persetujuan',
  'label.you_can_send_residential_project_to_leader': 'Kirim catatan mengenai Proyek Pemukiman kepada Award Leader untuk mendapatkan persetujuan',
  'label.you_have_finished_now_send_to_approval': 'Kegiatanmu telah selesai. Sekarang sampaikan pada Assessor untuk mendapat persetujuan. Tambahkan catatan pribadi bila perlu',
  'label.preparation_and_training': 'Persiapan dan Pelatihan',
  'label.you_will_be_redirected_to_the_payment': 'Kamu akan dialihkan ke proses pembayaran, dimana kamu dapat melakukan pembayaran menggunakan kartu kredit atau debit.',
  'label.you_will_be_the_first_award_leader': 'Anda akan menjadi Award Leader pertama di organisasi anda. Anda memiliki hak untuk menambah jumlah Award Leader, Peserta dan mengelola proses perolehan Award melalui sistem Online Record Book',
  'label.youll_receive_a_notification': 'Kamu akan mendapat pemberitahuan bila Award Leadermu telah menyetujui pendaftaran yang kamu sampaikan. Kamu dapat masuk ke ORB Next Generation (kamu hanya akses untuk fungsi tertentu saja, sampai Award Leadermu memberikan persetujuan atas pendaftaran)',
  'label.your_parent_email': 'Email Orang Tua/Wali',
  'label.your_parent_first_name': 'Nama Depan Orang Tua / Wali',
  'label.your_parent_last_name': 'Nama Belakang Orang Tua / Wali',
  'label.your_report_approve_now_send_to_leader': 'Laporanmu telah mendapat persetujuan Assessor. Kamu dapat menyampaikan kepada Award Leader untuk persetujuan selanjutnya. Kamu dapat menambahkan catatan bila dibutuhkan',
  'label.there_are_loads_of_exciting_possibilities': 'Ada banyak kemungkinan dan peluang. Pilih sesuatu yang paling bermakna.',
  'label.your_residential_project_has_been_setup': 'Proyek Pemukiman mu telah berhasil dibuat dan disampaikan kepada Award Leader untuk mendapatkan persetujan.',
  'label.your_report_has_been_sent_assessor': 'Laporanmu telah dikirim ke Assessor untuk mendapat persetujuan',
  'label.your_report_has_been_sent_leader': 'Laporanmu telah dikirim ke Award Leader untuk mendapat persetujuan',
  'label.your_residential_project_is_complete': 'Proyek Pemukiman telah lengkap',
  'label.to_work_on_the_online': 'Untuk menggunakan ORB kamu wajib memiliki akun ORB',
  'label.we_will_send_you_an_email': 'Kami akan mengirimkan email bila pendaftaran akun ORB mu mendapat persetujuan',
  'label.if_you_have_any_problems_or_doubts': 'Bila kamu menemui kesulitan atau merasa ragu, harap menghubungi Award Unit untuk informasi lebih lanjut',
  'label.are_you_sure_you_want_to_leave': 'Yakin ingin meninggalkan laman ini? Informasi akan hilang.',
  'label.no_logs_yet': 'Belum ada catatan. Coba buat catatan dengan menekan tombol "Tambah Catatan" ',
  'label.menu': 'Pilihan',
  'notifications.award_unit_has_been_created': 'Award Unit telah dibuat',
  'notifications.authorization_code_is_not_valid': 'Kode Otorisasi tidak sah',
  'notifications.email_has_been_confirmed': 'Alamat email telah dikonfirmasi',
  'notifications.leader_has_been_created': 'Award Leader telah dibuat',
  'notifications.participant_has_been_created': 'Peserta telah dibuat',
  'notifications.email_with_instructions_has_been_sent': 'Email dengan instruksi telah dikirim',
  'notifications.your_new_password_has_been_set': 'Kata sandi anda telah dikirim',
  'notifications.success': 'Berhasil',
  'notifications.unknown_role': 'Peran tidak diketahui',
  'notifications.waiting_for_approval': 'Menunggu persetujuan',
  'notifications.activity_cannot_be_created': 'Kegiatan tidak dapat dibuat sampai pendaftaran mendapat persetujuan',
  'notifications.new_activity_has_been_added': 'Kegiatan baru telah ditambahkan',
  'notifications.new_log_has_been_added': 'Catan baru telah di tambahkan',
  'notifications.log_has_been_deleted': 'Catatan telah dihapus',
  'notifications.log_has_been_modified': 'Catatan telah diubah/modifikasi',
  'notifications.adventurous_journey_cannot_be_created_until_approved': 'Perjalanan Bertualang tidak dapat dibuat sampai pendaftaran mendapat persetujuan',
  'notifications.new_participant_event_has_been_added': 'Kegiatan peserta baru telah ditambahkan',
  'notifications.participant_event_has_been_completed': 'Kegiatan peserta telah selesai',
  'notifications.training_and_practice_modified': 'Pelatihan dan Praktik telah diubah',
  'notifications.completion_residential_project_completed': 'Proyek Pemukiman telah diselesaikan',
  'notifications.new_residential_project_has_been_added': 'Proyek Pemukiman baru telah ditambahkan',
  'notifications.residential_project_cannot_be_created_until_approved': 'Proyek Pemukiman tidak dapat dibuat sampai registrasi mendapat persetujuan',
  'notifications.already_assessed_sent': 'Permohonan persetujuan Award Leader telah disampaikan',
  'notifications.assessment_request_sent': 'Permohonan Assessment telah disampaikan',
  'notifications.leader_approval_sent': 'Permohonan Persetujuan Award Leader telah disampaikan',
  'tabs.logs': 'Catatan catatan',
  'tabs.new': 'Baru',
  'tabs.overview': 'Garis Besar',
  'tabs.report': 'Laporan',
  'button.add_activity': 'Tambah kegiatan',
  'button.add_log': 'Tambah catatan',
  'button.continue_here': 'lanjutkan disini',
  'button.continue': 'lanjutkan',
  'button.continue_to_award': 'lanjutkan ke bagian Award',
  'button.delete': 'hapus',
  'button.edit': 'ubah',
  'button.edit_log': 'ubah catatan',
  'button.finish': 'selesai',
  'button.forgot_your_password': 'Lupa kata sandi?',
  'button.i_already_have_assessment': 'Saya telah memperoleh hasil assessment',
  'button.leave_anyway': 'Keluar',
  'button.login': 'Masuk',
  'button.no': 'Tidak',
  'button.register': 'Mendaftar',
  'button.send': 'kirim',
  'button.send_for_approval': 'kirim persetujuan',
  'button.setup': 'buat',
  'button.setup_residential': 'Buat Projek Pemukiman',
  'button.stay': 'Tinggal',
  'button.submit': 'Sampaikan',
  'button.update': 'Mutakhir',
  'button.yes': 'ya',
  'errors.at_least_num_characters': 'Paling tidak {x} karakter',
  'errors.do_not_match': 'Tidak cocok',
  'errors.include_at_least_one_number': 'Termasuk paling tidak 1 karakter bilangan',
  'errors.include_both_lower_and_upper_case': 'Menggunakan huruf kecil dan besar',
  'errors.invalid_phone_format': 'Format no telepon tidak valid',
  'errors.invalid_email_address': 'alamat email tidak valid',
  'errors.required_field': 'wajib dilengkapi',
  'errors.must_be_at_least': 'harap paling tidak mengandung {x} karakter',
  'errors.must_be_no_more_than': 'harap mengandung paling banyak {x} karakter',
  'errors.must_be_an_integer': 'harap merupakan bilangan bulat',
  'errors.must_contain_at_least': 'harap mengandung paling tidak 1 bilangan',
  'errors.must_include_at_least': 'harap mengandung paling tidak 1 karakter huruf besar',
  'errors.must_be_one_of': 'harap terdiri dari {enums}',
  'errors.you_must_be_younger_than': 'Kamu wajib dibawah usia {tahun} dan {bulan} untuk dapat mendaftar. Harap menghubungi Staf di Award Unit untuk keterangan lebih lanjut',
  'errors.you_must_be_older_than': 'Kamu wajib diatas usia {tahun} dan {bulan} untuk mendaftarkan diri menjadi Award Leader. Harap menghubungi Staf di Award Unitmu untuk keterangan lebih lanjut.',
  'errors.email_address_is_in_use_please_sign': 'Alamat email telah digunakan pihak, bila kamu ingin mendaftarkan diri untuk tingkat Award berikutnya, perintah masuk ke akun yang kamu miliki',
  'errors.email_address_is_in_use': 'Alamat email telah digunakan pihak lain.',
  'errors.sorry_we_already_have_this_email': 'Maaf kami telah memiliki akun dengan email ini. Bila kamu ingin memulai Award dengan tingkat yang baru. Masuk akun yang kamu miliki dan pilih Mulai TIngkat Award baru',
  'wizard.authorising_contact': 'Kontak yang memiliki otorisasi',
  'wizard.award_leader_contact': 'Kontak Award Leader',
  'wizard.award_unit_details': 'Info Lengkap Award Unit',
  'wizard.contact_details': 'Info Lengkap Kontak',
  'wizard.contacts': 'Kontak',
  'wizard.level': 'Tingkatan Award',
  'wizard.level_selection': 'Pilihan tingkat Award',
  'wizard.leader_details': 'Info Lengkap Award Leader',
  'wizard.nominated_award_leader': 'Award Leader yang dinominasikan',
  'wizard.orb_account': 'Akun ORB',
  'wizard.parent_consent': 'Persetujuan Orang Tua Murid',
  'wizard.participant_details': 'Info lengkap peserta',
  'wizard.profile': 'Profil',
  'wizard.payment': 'Pembayaran',
  'wizard.select_award_unit': 'Pilih Award Unit',
  'wizard.unit_details': 'Info Lengkap Award Unit',
  'wizard.welcome': 'Selamat Datang!',
  'wizard.your_details': 'Info lengkap mengenai anda',
  'awardUnit.do_you_want_to_create': 'Apakah anda ingin membuat Award Unit baru?',
  'parent.you_can_download_the_consent_here': 'Anda dapat mendonlod Formulir Persetujuan Orang Tua/Wali apabila anda belum memilikinya. Mintalah tandatangan Orang Tua/Wali dan kembalikan pada Award Leader.',
  'footer.copyright': "Hak Cipta dilindungi UU - c Copyright The Duke of Edinburgh's International Award {year}",
  'registration_participant.required_award_payment': 'Administrasi Pembayaran program Award',
  'registration_participant.pay_online_here': 'Membayar on line dan lakukan transaksi disini',
  'dashboard.activity_log_time': 'jam menit',
  'moduleTitle.award_completed': 'Award selesai dilakukan!',
  'notifications.award_approval_request_sent_to_leader': 'Permohonan persetujuan telah disampaikan kepada Award Leader',
  'notifications.new_participant_event_has_been_completed': 'Kegiatan peserta baru telah diselesaikan',
  'notifications.preparation_and_training_approval_sent': 'Persetujuan atas persiapan dan pelatihan telah disampaikan',
  'notifications.reparation_and_training_completed': 'Persiapan dan pelatihan telah selesai',
  'notifications.your_profile_photo_has_been_edited': 'Profil Foto telah diubah',
  'notifications.your_profile_has_been_edited': 'Profil anda telah diubah',
  'notifications.new_level_has_started': 'Tingkatan baru dimulai',
  'notifications.activity_has_been_edited': 'Kegiatan telah diedit',
  'notifications.you_have_been_logged_out': 'Keluar',
  'notifications.logging_out': 'Anda telah keluar dari system',
  'label.you_can_send_award_to_leader': 'Kamu dapat mengirimkan catatan kepada Award Leader untuk mendapatkan Approval',
  'label.you_have_completed_all_sections_of_your_award': 'Kamu telah berhasil menyelesaikan semua bidang kegiatan. Anda dapat menyampaikan semua catatan kepada Award Leader. Tambahkan catatan bila perlu',
  'label.you_have_now_completed_your_award': 'Kamu sekarang telah menyelesaikan {x} Award. Apakah kamu ingin melanjutkan ke tingkatan Award berikutnya?',
  'label.congratulation_your_award_has_been_approved': 'Selamat! {x) Awardmum mendapat persetujuan. Bila diinginkan. kamu dapat memulai tingkat Award berikutnya.',
  'moduleTitle.settings': 'Pengaturan',
  'moduleTitle.edit_activity': 'Edit Kegiatan',
  'moduleTitle.select_your_major_activity': 'Pilih kegiatan utama',
  'label.settings': 'Pengaturan',
  'label.major_activity_means_that_you_will': 'Kegiatan utama artinya kamu akan menghabiskan waktu lebih banyak untuk kegiatan ini dibandingkan dengan kegiatan lainnya. Untuk Award tingkat Emas atau Perak, waktu tambahan yang dipersyaratkan adalah 6 bulan, untuk Bronze 3 bulan.',
  'label.notifications': 'Pemberitahuan',
  'label.my_award': 'Award Ku',
  'label.physical_recreation': 'Rekreasi Fisik',
  'label.skill': 'Skill',
  'label.service': 'Pengabdian Masyarakat',
  'label.my_parent_will_complete_and_sign_form': 'Orang Tua/Wali saya telah melengkapi dan memberikan tanda persetujuan',
  'label.please_print_it_tak_it_to_your_parent': 'Harap cetak file ini, bicarakan dengan Ortu/Wali untuk memperoleh persetujuan dan berikan pada Award Leader kami. ',
  'label.change_password': 'Tukar kata sandi',
  'label.change_major_activity': 'Ubah Kegiatan utama',
  'title.change_password': 'Ubah sandi kunci',
  'label.old_again': 'Kata sandi lama',
  'label.new_password': 'Kata sandi baru',
  'label.new_password_again': 'Kata sandi baru lagi',
  'errors.passwords_dont_match': 'Kata sandi tidak cocok',
  'errors.more_than': 'Lebih dari',
  'button.parent_guardian_consent_pdf': 'Surat persetujuan Orang Tua Muris/Wali dari',
  'button.send_award_for_approval': 'Sampaikan catatan saya untuk persetujuan',
  'button.send_report': 'Kirim laporan',
  'button.terms_and_conditions': 'Tatacara Persyaratan dan Kondisi yang berlaku Internatonal',
  'button.privacy_policy': 'Kebijakat privasi',
  'button.save': 'Simpan',
  'button.start_new_level': 'Mulai dari awal ',
  'button.change_password': 'ubah kata sandi',
  'button.edit_activity': 'ubah kegiatan',
  'moduleTitle.file_upload': 'upload file',
  'label.add_file': 'tambah file',
  'label.description': 'Penjelasan',
  'label.waiting_for_office_sign_off': 'Menunggu persetujuan dari Kantor Award',
  'notifications.file_has_been_uploaded': 'Berkas telah di upload',
  'tabs.files': 'Berkas berkas',
  'button.upload': 'Upload',
  'button.upload_file': 'File upload',
  'button.add_file': 'Tambah file',
  'button.this_activity_has_no_assessor': 'Kegiatan ini tidak memiliki assessor.  Kamu diminta menyediakan data assessor lengkap sebelum mengirimkannya untuk mendapat persetujuan',
  'label.i_want_to_register_my_award': 'Saya ingin meregistrasikan Award Unit saya sebagai Independent Award Centre',
  'label.select_sub_operating_authority': 'Pilih sub Otorita Operasi',
  'label.your_must_first_setup_some_activity': 'Kamu wajib mengatur beberapa kegiatan terlebih dahulu',
  'label.you_cant_change_your_major_activity': 'Kamu tidak dapat merubah kegiatan utama. Kegiatan utama kamu telah dinyatakan lengkap.',
  'label.s_specific': "<b>S-Specifik: Tujuan mu tidak bisa terlalu melebar. </b> daripada meletakan tujuan: 'Saya ingin lebih baik pada permainan biola', kamu dapat mengatakan, ' Saya ingin mahir dalam sampai dengan skala F pada permainan biola'",
  'label.m_measurable': "<b> M- Measurable: Kamu harus bisa mengatakan kapan kamu mampu menyelesaikan tujuan. <b> Dari pada meletakan tujuan sebagai' Saya ingin membantu masyarakat', kamu bisa mengatakan,' Saya ingin menolong orang orang yang mengunjungi dapur umum dengan cara menyumbangkan waktu saya sebagai relawan seminggu sekali'. Dengan cara ini tujuan kamu dapat di nilai.",
  'label.a_achievable': ",b.A-Achievable: Tujuan mu harus merupakan sesuatu yang dapat kamu capai dalam jangka waktu Award yang kamu ambil. ,b. Dari pada mengatakan 'Saya ingin mengakhiri kemiskinan' jauh lebih baik bila kita dapat meletakan tujuan yang lebih praktis yaitu 'Saya ingin menggalang dana untuk dikirimkan keluar negeri untuk membantu pengembangan desa di dunia ketiga'.",
  'label.r_realistic': "<b> R-Realistik: Sama juga dengan 'Achievable'. <b> Apakah cukup 'Realistik' bahwa kamu dapat mencapai semua tujuanmu dalam jangka waktu yang tersedia?",
  'label.t_timely': "<b> T-Timely: Tujuan mu harus memasukan asepk kapan kamu akan mencapai tujuan. <b> Tujuan bisa saja merupakan keinginan menjadi mahir skala F dipermainan biola dalam waktu 3 bulan' ",
  'label.you_can_upload_here_any_files': 'Kamu dapat meng upload file yang ingin kamu bagikan dengan Award Leader mu.',
  'moduleTitle.login_change': 'Rubah Login',
  'notifications.adventurous_journey_modified': 'Perjalanan bertualang telah dirubah',
  'tabs.sections': 'Bidang',
  'label.change_email': 'Rubah email',
  'title.change_email': 'Rubah email',
  'label.new_email': 'Email baru',
  'label.new_email_again': 'Email baru lagi',
  'errors.emails_dont_match': 'Email tidak cocok',
  'button.change_email': 'Rubah email',
  'notifications.email_with_instructions_has_been_sent_to_your_inbox': 'Email dengan instruksi telah dikirim ke inboxmu',
  'global.dofe_name': 'The Duke of Edinburgh’s International Award',
  'global.or': 'atau',
  'route.landing_page': 'laman',
  'route.dashboard': 'dashboard',
  'moduleTitle.notifications': 'Notifikasi',
  'moduleTitle.no_notifications': 'Tidak ada notifikasi',
  'moduleTitle.new_notifications': 'Notifikasi baru',
  'moduleTitle.older_notifications': 'Notifikasi sebelumnya',
  'moduleTitle.user_guide': 'User guide',
  'label.user_guide': 'User guide',
  'notifications.your_password_has_been_changed': 'Kata kunci mu telah diganti',
  'label.country': 'Negara',
  'label.on_your_smartphone': 'tanda pada smart phone mu',
  'label.on_the_web': 'pada web',
  'label.orb_online': 'ORB online',
  'label.language': 'bahasa',
  'moduleTitle.participant_login': 'login peserta',
  'label.for_ios': 'IOS',
  'label.for_android': 'Android',
  'button.login_as_award_staff': 'Login sebagai Staf Award',
  'errors.leader_doesnt_exist': 'Leader tidak ditemukan',
  'global.loading': 'Loading',
  'moduleTitle.award_staff_login': 'Login sebagai Staf Award',
  'formTitle.residential_project_details': 'Info lengkap proyek pemukiman',
  'label.you_can_also_download_participant': 'Kamu dapat mengunduh <strong>Aplikasi Peserta kami yang baru </strong> dan mengakses Online Record Book setiap saat, dari mana pun.',
  'label.you_can_also_download_leader': 'Kamu dapat juga mendonlod <strong>Aplikasi Award leader</strong> yang baru dan meng akses Online Record Book setiap saat, dari mana pun.',
  'notifications.this_role_is_not': 'Peran ini saat ini tidak tersedia.',
  'notifications.residential_project_has_been_updated': 'Proyek pemukiman telah diperbaharui',
  'tabs.participant': 'Peserta',
  'tabs.award_staff': 'Staf Award',
  'moduleTitle.edit_residential_project': 'Edit Proyek Pemukiman',
  'button.residential_project': 'Edit Proyek Pemukiman',
  'notifications.your_login_email_has_been_changed': 'Login email mu telah dirubah',
  'meta.dofe_name': "The Duke of Edinburgh's International Award",
  'notifications.unknown_role_leader': 'Tidak dikenali - gunakan login staf Award',
  'notifications.unknown_role_participant': 'Tidak dikenali - gunakan login peserta',
  'label.user_guide_web_participant': 'User web guide - Peserta',
  'label.user_guide_app_participant': 'User app guide - peserta',
  'label.note_for_supervisor': 'Catatan untuk Supervisor',
  'label.before_submitting_your_aj': 'Sebelum mengirimkan cat perjalanan mu cheeped Award Leader, awalnya kamu wajib mendapat persetujuan dari {peran}. Bila diinginkan dapat menambahkan cat pribadi',
  'button.back_to_home': 'kembali',
  'moduleTitle.assessor_approval': 'Persetujuan dari {peran]',
  'label.this_aj_has_no_assessor': 'AJ tidak memiliki {peran}. Kamu wajib memperbaharui rincian catatan sebelum minta persetujuan',
  'route.not_found': 'tidak ditemukan',
  'notifications.are_you_sure': 'Kamu yakin?',
  'button.cancel': 'batal',
  'label.add_document': 'tambahkan dokumen',
  'errors.there_are_currently_no_details_for_your': 'Saat ini tidak ada rincian mengenai {peran} mu. Silahkan melengkapi semua data sebelum menyampaikan catatan untuk penilaian.',
  'moduleTitle.missing_data': 'Data tidak lengkap',
  'label.to_send_assessment_request': 'Apabila kamu ingin mengirimkan permohonan untuk penilaian secara elektronik, harap mengisi email yang dimiliki oleh {peran}',
  'label.pending_changes': 'perubahan yang masih ditunda',
  'label.some_fields_require': 'beberapa hal yang perlu perhatian',
  'roles.assessor': 'Assessor',
  'roles.supervisor': 'Supervisor',
  'pageTitle.register_participant': 'Pendaftaran Peserta',
  'moduleTitle.revise_message': 'Ubah pesan',
  'moduleTitle.payment_for_level': 'Pembayaran untuk {awardLevel}',
  'moduleTitle.payment': 'Pembayaran biaya registrasi peserta',
  'moduleTitle.we_have_sent_you_payment_link': 'Kami telah mengirimkan pada anda tautan untuk melakukan Gateway Pembayaran',
  'label.required_award_payment': 'Pembayaran Award yang dibutuhkan',
  'label.payment_fees': 'Biaya Pembayaran',
  'label.payment_method': 'Methode Pembayaran',
  'label.you_will_type_trans_id': 'Anda akan di minta untuk mengetikan ID transaksi anda',
  'label.any_level_previously': 'Tingkat Award yang pernah diselesaikan',
  'label.registering_for_level': 'Pendaftaran untuk tingkatan.',
  'notification.payment_link_expired': 'Tautan pembayaran telah kadaluwarsa',
  'button.pay': 'Tombol pembayaran',
  'label.registration_updated': 'Pendaftaran anda telah diperbaiki, anda dapat mentutup halaman ini',
  'label.award_leader_receive_payment': 'Award Leader anda akan menerima informasi mengenai tata cara pembayaran',
  'errors.end_date_after': 'hari akhir wajib merupakan hari setelah tanggal mulai di berikan',
  'button.back': 'Kembali',
  'button.edit_info': 'Ubah Informasi',
  'moduleTitle.level_detail': 'Tingkat Award secara terperinci',
  'label.payment_methods': 'Metode pembayaran',
  'label.address': 'Alamat',
  'note.review_filled_participant': 'Harap periksa informasi yang diisi oleh Peserta. Apabila anda menemukan kesalahan, anda dapat melakukan edit.',
  'moduleTitle.payment_successful': 'Pembayaran pendaftaran peserta berhasil',
  'button.proceed_to_login': 'Login',
  'label.add_additional_activity': 'Tambah kegiatan ',
  'moduleTitle.welcome_to_orb': 'Selamat datang di Online Record Book',
  'empty_dashboard.not_approved': 'Perangkat ini akan membantu kamu untuk merekam kemajuanmu selama kamu menjalankan program Award. Tapi profile mu belum di setujui oleh Award Leadermu. Sebelum kami membuat kegiatan awal, kamu harus menunggu untuk memperoleh persetujuan.',
  'empty_dashboard.approved_1': 'Perangkat ini akan membantu kami untuk merekam semua kemajuam mu selama menjalankan program Award.',
  'empty_dashboard.approved_2': 'Pertamatama, kamu harus menyusu kegiatan. Untuk memulainya, klik tombol sebelah kiri. Apabila kamu membutuhkan bantuan untuk menyusun kegiatan, mintalah bantuan Award Leader.',
  'label.discuss_activity_leader': 'Apabila kamu memilih lebih dari satu kegiatan, diskusikan hal ini dengan Award Leadermu terlebih dahulu',
  'label.cannot_add_activity': 'Kamu dapat menambahkan maksimum 3 kegiatan untuk setiap tingkatan Award. Harap diskusikan hal ini dengan Award Leader mu.',
  'button.ok': 'OK',
  'label.payment_was_canceled': 'Pembayaran telah di batalkan oleh pengguna/user',
  'label.problem_with_payment': 'Terdapat kesalahan dalam memproses pembayaranmu. Harap hubungi NAO.',
  'pageTitle.register_leader': 'Mendaftarkan Leader',
  'pageTitle.registration_complete': 'Pendaftaran telah selesai',
  'label.payment_link_expired_or_paid': 'Anda telah membayar biaya registrasi atau tautan pembayaran telah kadaluwarsa.',
  'label.contact_nao_assistance': 'HUbungi NAO bila membutuhkan bantuan',
  'label.send_required_amount_to_your_award_leader': 'Kirimkan sejumlah dana pada Award Leader atau Koordinator dalam Award Unit anda.',
  'label.fee_can_be_paid': 'Biaya dapat dibayarkan secara online menggunakan VISA, Mastercard, atau Credit Debit Card',
  'notifications.login_failed_right_tab': 'Login tidak berhasil. Pastikan anda berada dalam tab yang benar (Peserta/Staf Award)',
  'label.i_have_read_privacy_policy': 'Saya telah membaca Kebijakan Kerahasiaan dan menyatakan setuju',
  'errors.invalid_date_format': 'Formasi tanggal yang salah/invalid',
  'label.no_privacy_policy': 'Tidak ditemukan kebijakan kerahasiaan. Anda dapat secara aman memprosesnya dengan cara mengklik tombol selesai.',
  'label.status': 'status',
  'moduleTitle.attached_with_observation': 'observasi terlampir',
  'moduleTitle.revise_message_rp': 'Proyek Residensial mu telah direvisi oleh Award Leader',
  'file.activity_section_summary': 'Ringkasan bidang kegiatan',
  'label.download_section_summary': 'Download Ringkasan bidding kegiatan',
  'label.award_summary': 'Ringkasan Award',
  'btn.download_summary_for_assessor': 'Download ringkasan untuk assessor',
  'label.first_activity_started': 'kegiatan pertama telah dimulai',
  'label.hours_completed_required': 'jam yang diselesaikan/diwajibkan',
  'label.weeks_completed_required': 'minggu yang diselesaikan/diwajibkan',
  back_to_home: 'kembali ke laman awal',
  'label.activity_rejected_click': 'Kegiatanmu telah ditolak oleh Award Leader. Klik untuk ...',
  'button.more_information': 'informasi lebih lanjut',
  'label.attached_file': 'terlampir file',
  'moduleTitle.journey_details': 'rincian perjalanan',
  'tabs.activity': 'kegiatan',
  'label.confirm_email': 'konfirm email',
  'label.aj_rejected_click': 'perjalanan mu telah di tolak oleh Award Leader. Klik untuk...',
  'label.verifying_payment': 'Periksa Pembayaran',
  'button.finish_and_pay': 'Selesai dan lakukan pembayaran',
  'label.payment_not_successful_text': 'silahkan menyelesaikan pembayaran sekarang',
  'label.payment_not_completed': 'pembayaran belum diselesaikan',
  'button.pay_now': 'bayar sekarang',
  'label.registration_pending_parental_consent': 'Pendaftaran anda ditunda, menunggu persetujuan orang tua/wali',
  'button.edit_observation': 'edit observasi',
  'moduleTitle.qualifying': 'qualifying/penilaian',
  'moduleTitle.practice': 'latihan',
  'label.first_log_entry': 'masuk catatan awal',
  'label.first_log_entry_date': 'tanggal catatan awal',
  'label.last_log_entry': 'catatan akhir',
  'label.last_log_entry_date': 'tanggal catatan akhir',
  'label.you_can_send_journey_report_for_approval': 'kamu dapat mengirim laporan {journey} mu untuk memperoleh persetujuan ',
  'button.edit_and_resend_report': 'ubah dan kirim kembali laporan',
  'label.your_journey_is_complete': '{journeyType} mu dinyatakan lengkap',
  'button.add_additional_journey': 'tambahkan perjalanan tambahan',
  'moduleTitle.edit_journey': 'ubah perjalanan',
  'notifications.assessment_sent': 'assessment telah dikirimkan',
  'notifications.file_is_too_big': 'file tidak bisa di upload, mungkin terlalu besar',
  'notifications.authorization_code_has_expired': '',
  'route.confirm_email': '',
  'label.assessor_needs_account': '',
  'label.company_name': '',
  'label.secondary_email_again': '',
  'label.how_many_years': '',
  'label.no_company_leave_empty': '',
  'label.secondary_phone_number': '',
  'label.secondary_phone_type': '',
  'label.wwc_application_number': '',
  'label.wwc_expiration_date': '',
  'label.you_are_now_registering_as_assessor': '',
  'label.you_have_finished_aj_now_send_to_approval': '',
  'label.your_experience': '',
  'label.your_qualification': '',
  'notifications.waiting_for_assessor_approval': '',
  'button.resend_assessment_request': '',
  'errors.emails_must_be_different': '',
  'moduleTitle.company_details': '',
  'notifications.already_resent_assessment_request': '',
  'route.assessor_dashboard': '',
  'pageTitle.register_assessor': '',
  'wizard.assessor_details': '',
  'wizard.assessor_experience': '',
  'wizard.personal_details': '',
  'button.sign_off': '',
  'button.sign_off_dashed': '',
  'moduleTitle.sign_off': '',
  'label.certify_participant_met_reqs': '',
  'label.assessor_report': '',
  'label.content_update': '',
  'label.comment_on_participant_improvement': '',
  'note.edit_participant_review': '',
  'errors.min_age': '',
  'notifications.assessor_link_expired': '',
  'label.secondary_email': '',
  'moduleTitle.review_participant_info': '',
  'label.loading_payment_gateway': '',
  'label.consent_given_login_as_child': '',
  'notifications.only_one_qualification_journey_per_award': '',
  'label.registration_fees_participant': '',
  'moduleTitle.leader_details': '',
  'label.leader_name': '',
  'label.leader_phone': '',
  'label.leader_email': '',
  'moduleTitle.au_details': '',
  'label.au_name': '',
  'label.assessor_guidelines': '',
  'label.assessor_cond_req': '',
  'label.assessor_ref_handbook': '',
  'label.assessor_ref_online_modules': '',
  'label.participant_has_no_aj_report': '',
  'moduleTitle.participant_details': '',
  'label.participants_has_no_logs': '',
  'label.location_type': '',
  'label.activity_ready_for_signoff': '',
  'label.activities': '',
  'label.choose_how_you_want_to_login': '',
  'roles.leader': '',
  'roles.award_verifier': '',
  'roles.coordinator': '',
  'roles.aj_assessor': '',
  'roles.aj_supervisor': '',
  'roles.instructor': '',
  'roles.nao_staff': '',
  'roles.super_user': '',
  'roles.user': '',
  'roles.viewer': '',
  'roles.authorizing_contact': '',
  'roles.if_staff_superuser': '',
  'roles.if_staff_statistical_user': '',
  'roles.if_staff_viewer': '',
  'roles.aj_instructor': '',
  'label.if_you_have_questions_au': '',
  'label.we_will_send_you_an_email_leader': '',
  'moduleTitle.rejecting_assessor_invitation': '',
  'notifications.assessor_invitation_rejected': '',
  'moduleTitle.participants_list_is_empty': '',
  'label.note_from_participant': '',
  'label.you_can_send_aj_to_leader': '',
  'button.save_report': '',
  'label.this_activity_has_no_assessor': '',
  'label.activity_rejected_click_by_assessor': '',
  'button.reject': '',
  'button.reject_invitation': '',
  'label.reason': '',
  'label.accept_invitation_and_continue': '',
  'pageTitle.registration_reject': '',
  'errors.you_must_be_older_than_register_for_leader': '',
  'label.your_report_approve_now_send_to_leader_without_note': '',
  'button.stop_assessing_this_activity': '',
  'button.confirm': '',
  'moduleTitle.are_you_sure': '',
  'label.content_restore': '',
  'button.stop_editing': '',
  'notifications.activity_has_been_rejected': '',
  'notifications.aj_has_been_rejected': '',
  'notifications.rp_has_been_rejected': '',
  'moduleTitle.additional_files': '',
  'moduleTitle.no_additional_files': '',
  'moduleTitle.stop_assessing_section': '',
  'label.show_security_and_refund_policy': '',
  'moduleTitle.security_and_refund_policy': '',
  'label.fees_payment': '',
  'label.redund_policy': '',
  'label.security_policy': '',
  'label.leave_blank': '',
  'label.frequently_asked_questions': '',
  'label.language_selection_is_disabled_for_iac': '',
  'errors.min_nights_required': '',
  'label.completion_date': '',
  'label.you_are_offline': '',
  'errors.start_date_after_award_start': '',
  'label.participants': '',
  'label.marketing_from_iaf': '',
  'label.marketing_from_oa': '',
  'label.marketing_from_nao': '',
  'label.select_iac': '',
  'label.you_will_be_redirected_to_the_paypal_payment': '',
  'notifications.report_has_been_sent': '',
  'label.processing_paypal_payment': '',
  'label.loading_paypal_gateway': '',
  'label.payment_failed': '',
  'label.payment_has_been_cancelled': '',
  'roles.naa_oa_staff': '',
  'label.download_report_and_upload_signed_version': '',
  'button.download_summary_for_assessor': '',
  'label.pay_online_mastercard': '',
  'label.pay_online_paypal': '',
  'notifications.authorization_code_is_missing': '',
  'errors.unknown_payment_error': '',
  'errors.already_in_use_by_auth_contact': '',
  'roles.if_staff_stat_user': '',
  'moduleTitle.you_have_been_logged_out_due_to_inactivity': '',
  'announcement.survey_description.do_think_people_are_lazy': '',
  'announcement.survey_title.join_our_global_survey': '',
  'announcement.survey_button.if_below_25': '',
  'announcement.survey_button.if_over_25': '',
  'moduleTitle.privacy_and_cookie_policy': '',
  'label.we_have_made_some_important_changes': '',
  'button.i_agree': '',
  'button.see_more_details': '',
  'label.the_cookie_settings_on_this': ''
}
